import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { combineLatest, finalize, shareReplay, tap } from 'rxjs';
import { ClickEventTags, ModalEventTags } from 'src/app/services/gtm/gtm-types';
import { GtmService } from 'src/app/services/gtm/gtm.service';
import { LoaderService } from 'src/app/services/loader/loader.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { SnackbarService } from 'src/app/services/snackbars/snackbar.service';
import { StoreService } from 'src/app/services/store/store.service';
import { SnackbarMessageKey } from 'src/app/utils/enums';
import { buildRequestGenerateOtp, differentPhoneValidator } from 'src/app/utils/utils';

@Component({
	selector: 'app-update-phone-modal',
	templateUrl: './update-phone-modal.component.html',
	styleUrls: ['./update-phone-modal.component.scss'],
})
export class UpdatePhoneModalComponent implements OnInit {
	readonly vm$ = combineLatest({
		customer: this.storeService.customerData$,
		loaderButton: this.loaderService.loaderButton$,
	}).pipe(
		tap(({ customer }) => {
			if (customer) this.setDynamicValidator(customer.phoneNumber);
		}),
		shareReplay(1)
	);

	formInputPhone = this.fb.nonNullable.group({
		phoneNumber: this.fb.nonNullable.control('', {
			validators: [Validators.required, Validators.minLength(12)],
		}),
	});

	constructor(
		private readonly modalService: ModalService,
		private readonly loaderService: LoaderService,
		private readonly snackbarService: SnackbarService,
		private readonly storeService: StoreService,
		private readonly fb: FormBuilder,
		private readonly gtmService: GtmService
	) {
		this.modalService.setStyles({ containerStyle: { padding: '0px' } });
	}
	ngOnInit(): void {
		this.gtmService.handlerEvent(ModalEventTags.editPhone);
	}

	get phoneControl() {
		return this.formInputPhone.controls.phoneNumber;
	}

	private setDynamicValidator(customerPhone: string): void {
		this.phoneControl.addValidators(differentPhoneValidator(customerPhone));
		this.phoneControl.updateValueAndValidity({ emitEvent: false });
	}

	onUpdatePhone(companyRut: string, isLoader: boolean): void {
		if (this.formInputPhone.invalid || isLoader) return;
		this.gtmService.handlerEvent(ClickEventTags.updatePhone);

		const request = buildRequestGenerateOtp(companyRut, this.phoneControl.value);
		this.storeService
			.generateSendOtp(request, true)
			.pipe(
				finalize(() => {
					this.snackbarService.show(SnackbarMessageKey.OTP_SENT);
					this.modalService.closeModal();
				})
			)
			.subscribe();
	}
}
